import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IncubateePageComponent } from './components/incubatee-page/incubatee-page.component';
import { IncubateeListComponent } from './components/incubatee-list/incubatee-list.component';
import { IncubateeAddComponent } from './components/incubatee-add/incubatee-add.component';

const routes: Routes = [
  {
    path: '', component: IncubateePageComponent, data: { title: '' },
    children: [
      {
        path: '', component: IncubateeListComponent, data: { title: '' }
      },
      {
        path: ':name', component: IncubateeAddComponent, data: { title: 'Add' }
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IncubateeRoutingModule { }
